export default __webpack_public_path__ + "static/media/7.33bb8475.jpg";